<template>
  <v-content>
    <v-container class="fill-height pa-0">
      <v-row class="fill-height ma-0 text-center" align="center" justify="center">
        <v-col>
          <div class="display-1 mb-5">Wap a Bap App</div>
          <template v-if="isAuthenticated">
            <div class="ma-3">Logged in as: {{ email }}</div>
            <v-btn to="/" color="teal">Continue to App</v-btn>
            <v-btn @click="signOut" class="ma-3" color="pink">Logout</v-btn>
          </template>
          <template v-else>
            <v-btn class="ma-3" @click="signIn" color="teal">
              Login with Google
            </v-btn>
          </template>
          <div class="ma-3">{{ error }}</div>
        </v-col>
      </v-row>
    </v-container>
  </v-content>
</template>

<script>
import {auth, googleProvider} from '../firebase';
import {mapGetters} from 'vuex';

export default {
  name: 'Login',
  data() {
    return {
      error: ''
    };
  },
  computed: {
    ...mapGetters('auth', [
      'email',
      'isAuthenticated'
    ])
  },
  methods: {
    signIn() {
      auth.signInWithRedirect(googleProvider)
          .catch(error => {
            this.error = error;
            this.$logger.error(error);
          });
    },
    signOut() {
      auth.signOut().catch(error => {
        this.error = error;
        this.$logger.error(error);
      });
    }
  }
}
</script>
